import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@upme/ui/components/alert-dialog';
import { Button } from '@upme/ui/components/button';
import { Loader2 } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';
import { useImportNhatrangGuide } from '../mutations';

export function ImportNhatrangGuideButton() {
  const [open, setOpen] = useState(false);
  const mutation = useImportNhatrangGuide();

  const onConfirm = async () => {
    try {
      const result = await mutation.mutateAsync();
      setOpen(false);
      if (result.created === 0) {
        toast.message('Новых экскурсий нет', {
          description: `Пропущено (уже в БД или не прошли фильтр): ${result.skipped}`,
        });
      } else {
        toast.success(`Добавлено в «Гид»: ${result.created}`, {
          description: result.createdTitles.slice(0, 3).join(' · '),
        });
      }
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Не удалось импортировать';
      toast.error(message);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        <Button variant="outline" type="button">
          Заполнить «Гид»
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Импорт экскурсий в «Гид»</AlertDialogTitle>
          <AlertDialogDescription>
            Загрузит туры Нячанга из seed-файла на сервере (Катюша Тур и др.) как опубликованные услуги во
            вкладку mini-app «Гид». Уже существующие по названию и контакту не дублируются.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={mutation.isPending}>Отмена</AlertDialogCancel>
          <AlertDialogAction
            disabled={mutation.isPending}
            onClick={(e) => {
              e.preventDefault();
              void onConfirm();
            }}
          >
            {mutation.isPending ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Импорт…
              </>
            ) : (
              'Импортировать'
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
